import Axios from '@/assets/js/AxiosPlugin'

// 用户登录
export const login = params => { return Axios.post('/api/Admin/Public/login', params) }

// 退出登录
export const logout = params => { return Axios.post('/api/Admin/Public/logout', params) }

// 重置密码
export const resetPassword = params => { return Axios.post('/api/Admin/User/modifyPassword', params) }

// 获取用户信息
export const getUserInfo = params => { return Axios.post('/api/Admin/User/getUserInfo', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/UserMgmt/login/apis/index.js